import React from "react";

export const Svgs = {
  SettingsGear: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.4 44L18.4 37.7C17.7667 37.4667 17.1 37.15 16.4 36.75C15.7 36.35 15.0833 35.9333 14.55 35.5L8.65 38.2L4 30L9.4 26.05C9.33333 25.75 9.29167 25.4083 9.275 25.025C9.25833 24.6417 9.25 24.3 9.25 24C9.25 23.7 9.25833 23.3583 9.275 22.975C9.29167 22.5917 9.33333 22.25 9.4 21.95L4 18L8.65 9.8L14.55 12.5C15.0833 12.0667 15.7 11.65 16.4 11.25C17.1 10.85 17.7667 10.55 18.4 10.35L19.4 4H28.6L29.6 10.3C30.2333 10.5333 30.9083 10.8417 31.625 11.225C32.3417 11.6083 32.95 12.0333 33.45 12.5L39.35 9.8L44 18L38.6 21.85C38.6667 22.1833 38.7083 22.5417 38.725 22.925C38.7417 23.3083 38.75 23.6667 38.75 24C38.75 24.3333 38.7417 24.6833 38.725 25.05C38.7083 25.4167 38.6667 25.7667 38.6 26.1L44 30L39.35 38.2L33.45 35.5C32.9167 35.9333 32.3083 36.3583 31.625 36.775C30.9417 37.1917 30.2667 37.5 29.6 37.7L28.6 44H19.4ZM24 30.5C25.8 30.5 27.3333 29.8667 28.6 28.6C29.8667 27.3333 30.5 25.8 30.5 24C30.5 22.2 29.8667 20.6667 28.6 19.4C27.3333 18.1333 25.8 17.5 24 17.5C22.2 17.5 20.6667 18.1333 19.4 19.4C18.1333 20.6667 17.5 22.2 17.5 24C17.5 25.8 18.1333 27.3333 19.4 28.6C20.6667 29.8667 22.2 30.5 24 30.5Z"
        fill="black"
      />
    </svg>
  ),
  Download: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#fff"
      {...props}
    >
      <path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  HomeTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      viewBox="0 0 48 48"
      height={48}
      width={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 42V18L24.1 6L40 18V42H28.3V27.75H19.65V42H8ZM11 39H16.65V24.75H31.3V39H37V19.5L24.1 9.75L11 19.5V39Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  LocationTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 33.1C27.4667 30.3 30.0833 27.6083 31.85 25.025C33.6167 22.4417 34.5 20.0333 34.5 17.8C34.5 15.8333 34.1417 14.1667 33.425 12.8C32.7083 11.4333 31.825 10.3167 30.775 9.45C29.725 8.58333 28.5833 7.95833 27.35 7.575C26.1167 7.19167 25 7 24 7C23 7 21.8833 7.19167 20.65 7.575C19.4167 7.95833 18.275 8.58333 17.225 9.45C16.175 10.3167 15.2917 11.4333 14.575 12.8C13.8583 14.1667 13.5 15.8333 13.5 17.8C13.5 20.0333 14.3833 22.4417 16.15 25.025C17.9167 27.6083 20.5333 30.3 24 33.1ZM24 36.9C19.4333 33.4667 16.0417 30.1833 13.825 27.05C11.6083 23.9167 10.5 20.8333 10.5 17.8C10.5 15.5333 10.9083 13.5417 11.725 11.825C12.5417 10.1083 13.6 8.66667 14.9 7.5C16.2 6.33333 17.65 5.45833 19.25 4.875C20.85 4.29167 22.4333 4 24 4C25.5667 4 27.15 4.29167 28.75 4.875C30.35 5.45833 31.8 6.33333 33.1 7.5C34.4 8.66667 35.4583 10.1083 36.275 11.825C37.0917 13.5417 37.5 15.5333 37.5 17.8C37.5 20.8333 36.3917 23.9167 34.175 27.05C31.9583 30.1833 28.5667 33.4667 24 36.9ZM24 21C24.9667 21 25.7917 20.6583 26.475 19.975C27.1583 19.2917 27.5 18.4667 27.5 17.5C27.5 16.5333 27.1583 15.7083 26.475 15.025C25.7917 14.3417 24.9667 14 24 14C23.0333 14 22.2083 14.3417 21.525 15.025C20.8417 15.7083 20.5 16.5333 20.5 17.5C20.5 18.4667 20.8417 19.2917 21.525 19.975C22.2083 20.6583 23.0333 21 24 21ZM10.5 44V41H37.5V44H10.5Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  NewEmailTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 40C6.2 40 5.5 39.7 4.9 39.1C4.3 38.5 4 37.8 4 37V11C4 10.2 4.3 9.5 4.9 8.9C5.5 8.3 6.2 8 7 8H28.7C28.6 8.5 28.5333 9 28.5 9.5C28.4667 10 28.4833 10.5 28.55 11H7.25L24 21.9L31.55 17C31.8833 17.3 32.2333 17.575 32.6 17.825C32.9667 18.075 33.35 18.3 33.75 18.5L24 24.9L7 13.75V37H41V19C41.5667 18.8333 42.0917 18.6083 42.575 18.325C43.0583 18.0417 43.5333 17.7167 44 17.35V37C44 37.8 43.7 38.5 43.1 39.1C42.5 39.7 41.8 40 41 40H7ZM38 15.5C36.4667 15.5 35.1667 14.9667 34.1 13.9C33.0333 12.8333 32.5 11.5333 32.5 10C32.5 8.46667 33.0333 7.16667 34.1 6.1C35.1667 5.03333 36.4667 4.5 38 4.5C39.5333 4.5 40.8333 5.03333 41.9 6.1C42.9667 7.16667 43.5 8.46667 43.5 10C43.5 11.5333 42.9667 12.8333 41.9 13.9C40.8333 14.9667 39.5333 15.5 38 15.5Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  UserSettingTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 23.75C17.8 23.75 16 23.05 14.6 21.65C13.2 20.25 12.5 18.45 12.5 16.25C12.5 14.05 13.2 12.25 14.6 10.85C16 9.45 17.8 8.75 20 8.75C22.2 8.75 24 9.45 25.4 10.85C26.8 12.25 27.5 14.05 27.5 16.25C27.5 18.45 26.8 20.25 25.4 21.65C24 23.05 22.2 23.75 20 23.75ZM4 39.8V35.1C4 33.9333 4.29167 32.8833 4.875 31.95C5.45833 31.0167 6.3 30.3 7.4 29.8C9.8 28.7333 12.025 27.9667 14.075 27.5C16.125 27.0333 18.1 26.8 20 26.8H21.15C20.95 27.2667 20.8 27.725 20.7 28.175C20.6 28.625 20.5167 29.1667 20.45 29.8H20C18.0667 29.8 16.175 30.0083 14.325 30.425C12.475 30.8417 10.5667 31.5333 8.6 32.5C8.06667 32.7667 7.66667 33.1417 7.4 33.625C7.13333 34.1083 7 34.6 7 35.1V36.8H20.45C20.6167 37.4 20.8167 37.9417 21.05 38.425C21.2833 38.9083 21.5667 39.3667 21.9 39.8H4ZM33.35 42L32.85 38.7C32.2833 38.5333 31.7083 38.2917 31.125 37.975C30.5417 37.6583 30.05 37.3 29.65 36.9L26.9 37.5L25.65 35.4L28 33.2C27.9333 32.9 27.9 32.4833 27.9 31.95C27.9 31.4167 27.9333 31 28 30.7L25.65 28.5L26.9 26.4L29.65 27C30.05 26.6 30.5417 26.2417 31.125 25.925C31.7083 25.6083 32.2833 25.3667 32.85 25.2L33.35 21.9H36.05L36.55 25.2C37.1167 25.3667 37.6917 25.6083 38.275 25.925C38.8583 26.2417 39.35 26.6 39.75 27L42.5 26.4L43.75 28.5L41.4 30.7C41.4667 31 41.5 31.4167 41.5 31.95C41.5 32.4833 41.4667 32.9 41.4 33.2L43.75 35.4L42.5 37.5L39.75 36.9C39.35 37.3 38.8583 37.6583 38.275 37.975C37.6917 38.2917 37.1167 38.5333 36.55 38.7L36.05 42H33.35ZM34.7 35.95C35.9 35.95 36.8667 35.5833 37.6 34.85C38.3333 34.1167 38.7 33.15 38.7 31.95C38.7 30.75 38.3333 29.7833 37.6 29.05C36.8667 28.3167 35.9 27.95 34.7 27.95C33.5 27.95 32.5333 28.3167 31.8 29.05C31.0667 29.7833 30.7 30.75 30.7 31.95C30.7 33.15 31.0667 34.1167 31.8 34.85C32.5333 35.5833 33.5 35.95 34.7 35.95ZM20 20.75C21.3 20.75 22.375 20.325 23.225 19.475C24.075 18.625 24.5 17.55 24.5 16.25C24.5 14.95 24.075 13.875 23.225 13.025C22.375 12.175 21.3 11.75 20 11.75C18.7 11.75 17.625 12.175 16.775 13.025C15.925 13.875 15.5 14.95 15.5 16.25C15.5 17.55 15.925 18.625 16.775 19.475C17.625 20.325 18.7 20.75 20 20.75Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  CautionNoteTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 34C24.4667 34 24.875 33.825 25.225 33.475C25.575 33.125 25.75 32.7167 25.75 32.25C25.75 31.7833 25.575 31.375 25.225 31.025C24.875 30.675 24.4667 30.5 24 30.5C23.5333 30.5 23.125 30.675 22.775 31.025C22.425 31.375 22.25 31.7833 22.25 32.25C22.25 32.7167 22.425 33.125 22.775 33.475C23.125 33.825 23.5333 34 24 34ZM22.45 27.4H25.45V14H22.45V27.4ZM9 39H39V9H9V39ZM9 42C8.16667 42 7.45833 41.7083 6.875 41.125C6.29167 40.5417 6 39.8333 6 39V9C6 8.16667 6.29167 7.45833 6.875 6.875C7.45833 6.29167 8.16667 6 9 6H19.25C19.4167 4.83333 19.95 3.875 20.85 3.125C21.75 2.375 22.8 2 24 2C25.2 2 26.25 2.375 27.15 3.125C28.05 3.875 28.5833 4.83333 28.75 6H39C39.8333 6 40.5417 6.29167 41.125 6.875C41.7083 7.45833 42 8.16667 42 9V39C42 39.8333 41.7083 40.5417 41.125 41.125C40.5417 41.7083 39.8333 42 39 42H9ZM24 8.15C24.4667 8.15 24.875 7.975 25.225 7.625C25.575 7.275 25.75 6.86667 25.75 6.4C25.75 5.93333 25.575 5.525 25.225 5.175C24.875 4.825 24.4667 4.65 24 4.65C23.5333 4.65 23.125 4.825 22.775 5.175C22.425 5.525 22.25 5.93333 22.25 6.4C22.25 6.86667 22.425 7.275 22.775 7.625C23.125 7.975 23.5333 8.15 24 8.15Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  CautionHexagonTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 42L6 31.5V16.5L16.5 6H31.5L42 16.5V31.5L31.5 42H16.5ZM24 33.95C24.4667 33.95 24.875 33.775 25.225 33.425C25.575 33.075 25.75 32.6667 25.75 32.2C25.75 31.7333 25.575 31.325 25.225 30.975C24.875 30.625 24.4667 30.45 24 30.45C23.5333 30.45 23.125 30.625 22.775 30.975C22.425 31.325 22.25 31.7333 22.25 32.2C22.25 32.6667 22.425 33.075 22.775 33.425C23.125 33.775 23.5333 33.95 24 33.95ZM22.5 26.75H25.5V13.6H22.5V26.75ZM17.75 39H30.25L39 30.25V17.75L30.25 9H17.75L9 17.75V30.25L17.75 39Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  CautionTriangle: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 42L24 4L46 42H2ZM22.7 30.6H25.7V19.4H22.7V30.6ZM24.2 36.15C24.6333 36.15 24.9917 36.0083 25.275 35.725C25.5583 35.4417 25.7 35.0833 25.7 34.65C25.7 34.2167 25.5583 33.8583 25.275 33.575C24.9917 33.2917 24.6333 33.15 24.2 33.15C23.7667 33.15 23.4083 33.2917 23.125 33.575C22.8417 33.8583 22.7 34.2167 22.7 34.65C22.7 35.0833 22.8417 35.4417 23.125 35.725C23.4083 36.0083 23.7667 36.15 24.2 36.15ZM7.2 39H40.8L24 10L7.2 39Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  GearTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.4 44L18.4 37.7C17.7667 37.4667 17.1 37.15 16.4 36.75C15.7 36.35 15.0833 35.9333 14.55 35.5L8.65 38.2L4 30L9.4 26.05C9.33333 25.75 9.29167 25.4083 9.275 25.025C9.25833 24.6417 9.25 24.3 9.25 24C9.25 23.7 9.25833 23.3583 9.275 22.975C9.29167 22.5917 9.33333 22.25 9.4 21.95L4 18L8.65 9.8L14.55 12.5C15.0833 12.0667 15.7 11.65 16.4 11.25C17.1 10.85 17.7667 10.55 18.4 10.35L19.4 4H28.6L29.6 10.3C30.2333 10.5333 30.9083 10.8417 31.625 11.225C32.3417 11.6083 32.95 12.0333 33.45 12.5L39.35 9.8L44 18L38.6 21.85C38.6667 22.1833 38.7083 22.5417 38.725 22.925C38.7417 23.3083 38.75 23.6667 38.75 24C38.75 24.3333 38.7417 24.6833 38.725 25.05C38.7083 25.4167 38.6667 25.7667 38.6 26.1L44 30L39.35 38.2L33.45 35.5C32.9167 35.9333 32.3083 36.3583 31.625 36.775C30.9417 37.1917 30.2667 37.5 29.6 37.7L28.6 44H19.4ZM24 30.5C25.8 30.5 27.3333 29.8667 28.6 28.6C29.8667 27.3333 30.5 25.8 30.5 24C30.5 22.2 29.8667 20.6667 28.6 19.4C27.3333 18.1333 25.8 17.5 24 17.5C22.2 17.5 20.6667 18.1333 19.4 19.4C18.1333 20.6667 17.5 22.2 17.5 24C17.5 25.8 18.1333 27.3333 19.4 28.6C20.6667 29.8667 22.2 30.5 24 30.5ZM24 27.5C23.0333 27.5 22.2083 27.1583 21.525 26.475C20.8417 25.7917 20.5 24.9667 20.5 24C20.5 23.0333 20.8417 22.2083 21.525 21.525C22.2083 20.8417 23.0333 20.5 24 20.5C24.9667 20.5 25.7917 20.8417 26.475 21.525C27.1583 22.2083 27.5 23.0333 27.5 24C27.5 24.9667 27.1583 25.7917 26.475 26.475C25.7917 27.1583 24.9667 27.5 24 27.5ZM21.8 41H26.2L26.9 35.4C28 35.1333 29.0417 34.7167 30.025 34.15C31.0083 33.5833 31.9 32.9 32.7 32.1L38 34.4L40 30.8L35.3 27.35C35.4333 26.7833 35.5417 26.225 35.625 25.675C35.7083 25.125 35.75 24.5667 35.75 24C35.75 23.4333 35.7167 22.875 35.65 22.325C35.5833 21.775 35.4667 21.2167 35.3 20.65L40 17.2L38 13.6L32.7 15.9C31.9333 15.0333 31.0667 14.3083 30.1 13.725C29.1333 13.1417 28.0667 12.7667 26.9 12.6L26.2 7H21.8L21.1 12.6C19.9667 12.8333 18.9083 13.2333 17.925 13.8C16.9417 14.3667 16.0667 15.0667 15.3 15.9L10 13.6L8 17.2L12.7 20.65C12.5667 21.2167 12.4583 21.775 12.375 22.325C12.2917 22.875 12.25 23.4333 12.25 24C12.25 24.5667 12.2917 25.125 12.375 25.675C12.4583 26.225 12.5667 26.7833 12.7 27.35L8 30.8L10 34.4L15.3 32.1C16.1 32.9 16.9917 33.5833 17.975 34.15C18.9583 34.7167 20 35.1333 21.1 35.4L21.8 41Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  DocumentTheme: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.95 35.5H32.05V32.5H15.95V35.5ZM15.95 27H32.05V24H15.95V27ZM11 44C10.2 44 9.5 43.7 8.9 43.1C8.3 42.5 8 41.8 8 41V7C8 6.2 8.3 5.5 8.9 4.9C9.5 4.3 10.2 4 11 4H29.05L40 14.95V41C40 41.8 39.7 42.5 39.1 43.1C38.5 43.7 37.8 44 37 44H11ZM27.55 16.3V7H11V41H37V16.3H27.55Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  ReportNote: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 42C8.16667 42 7.45833 41.7083 6.875 41.125C6.29167 40.5417 6 39.8333 6 39V9C6 8.16667 6.29167 7.45833 6.875 6.875C7.45833 6.29167 8.16667 6 9 6H19.25C19.4167 4.83333 19.95 3.875 20.85 3.125C21.75 2.375 22.8 2 24 2C25.2 2 26.25 2.375 27.15 3.125C28.05 3.875 28.5833 4.83333 28.75 6H39C39.8333 6 40.5417 6.29167 41.125 6.875C41.7083 7.45833 42 8.16667 42 9V39C42 39.8333 41.7083 40.5417 41.125 41.125C40.5417 41.7083 39.8333 42 39 42H9ZM9 39H39V9H9V39ZM14 34H27.65V31H14V34ZM14 25.5H34V22.5H14V25.5ZM14 17H34V14H14V17ZM24 8.15C24.4667 8.15 24.875 7.975 25.225 7.625C25.575 7.275 25.75 6.86667 25.75 6.4C25.75 5.93333 25.575 5.525 25.225 5.175C24.875 4.825 24.4667 4.65 24 4.65C23.5333 4.65 23.125 4.825 22.775 5.175C22.425 5.525 22.25 5.93333 22.25 6.4C22.25 6.86667 22.425 7.275 22.775 7.625C23.125 7.975 23.5333 8.15 24 8.15Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  FaqHelp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48px"
      viewBox="0 0 24 24"
      width="48px"
      fill="#1C4F96"
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z" />
    </svg>
  ),
  UserGuide: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4_24)">
        <path
          d="M40 4H16C13.8 4 12 5.8 12 8V32C12 34.2 13.8 36 16 36H40C42.2 36 44 34.2 44 32V8C44 5.8 42.2 4 40 4ZM40 32H16V8H40V32ZM8 12H4V40C4 42.2 5.8 44 8 44H36V40H8V12ZM32 24V18C32 16.9 31.1 16 30 16H26V26H30C31.1 26 32 25.1 32 24ZM28 18H30V24H28V18ZM36 22H38V20H36V18H38V16H34V26H36V22ZM20 22H22C23.1 22 24 21.1 24 20V18C24 16.9 23.1 16 22 16H18V26H20V22ZM20 18H22V20H20V18Z"
          fill="#1C4F96"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_24">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  VideoSetting: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_4_27)">
        <path
          d="M7.2 12H40.8V21.6H43.2V12C43.2 10.68 42.12 9.6 40.8 9.6H7.2C5.88 9.6 4.8 10.68 4.8 12V36C4.8 37.32 5.88 38.4 7.2 38.4H26.4V36H7.2V12Z"
          fill="#1C4F96"
        />
        <path
          d="M45.84 34.08L47.928 32.424L45.816 28.776L43.344 29.736C42.96 29.448 42.528 29.208 42.072 29.016L41.712 26.4H37.512L37.128 29.04C36.696 29.232 36.264 29.472 35.88 29.76L33.384 28.776L31.272 32.424L33.36 34.104C33.312 34.584 33.288 35.064 33.36 35.544L31.272 37.2L33.384 40.848L35.856 39.888C36.24 40.176 36.672 40.416 37.128 40.608L37.512 43.2H41.712L42.096 40.56C42.528 40.368 42.96 40.128 43.344 39.84L45.84 40.824L47.952 37.176L45.864 35.496C45.888 35.016 45.888 34.56 45.84 34.08ZM39.6 37.2C38.28 37.2 37.2 36.12 37.2 34.8C37.2 33.48 38.28 32.4 39.6 32.4C40.92 32.4 42 33.48 42 34.8C42 36.12 40.92 37.2 39.6 37.2Z"
          fill="#1C4F96"
        />
        <path d="M19.2 31.2L30 24L19.2 16.8V31.2Z" fill="#1C4F96" />
      </g>
      <defs>
        <clipPath id="clip0_4_27">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  WorkAccepted: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.05 33.1L35.2 18.95L32.9 16.7L21.05 28.55L15.05 22.55L12.8 24.8L21.05 33.1ZM24 44C21.2667 44 18.6833 43.475 16.25 42.425C13.8167 41.375 11.6917 39.9417 9.875 38.125C8.05833 36.3083 6.625 34.1833 5.575 31.75C4.525 29.3167 4 26.7333 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05833 11.65 9.875 9.85C11.6917 8.05 13.8167 6.625 16.25 5.575C18.6833 4.525 21.2667 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24C44 26.7333 43.475 29.3167 42.425 31.75C41.375 34.1833 39.95 36.3083 38.15 38.125C36.35 39.9417 34.2333 41.375 31.8 42.425C29.3667 43.475 26.7667 44 24 44Z"
        fill="#1BA000"
      />
    </svg>
  ),
  WorkRejected: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      viewBox="0 96 960 960"
      width="48"
      fill="#ff0000"
      {...props}
    >
      <path d="m330 768 150-150 150 150 42-42-150-150 150-150-42-42-150 150-150-150-42 42 150 150-150 150 42 42Zm150 208q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Z" />
    </svg>
  ),
  RequestRejected: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      viewBox="0 96 960 960"
      width="48"
      fill="#ff0000"
      {...props}
    >
      <path d="m330 768 150-150 150 150 42-42-150-150 150-150-42-42-150 150-150-150-42 42 150 150-150 150 42 42Zm150 208q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Z" />
    </svg>
  ),
  RequestPending: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3059 26.5C14.002 26.5 14.5917 26.2564 15.075 25.7691C15.5583 25.2819 15.8 24.6902 15.8 23.9941C15.8 23.298 15.5564 22.7083 15.0691 22.225C14.5819 21.7417 13.9902 21.5 13.2941 21.5C12.598 21.5 12.0083 21.7436 11.525 22.2309C11.0417 22.7181 10.8 23.3098 10.8 24.0059C10.8 24.702 11.0436 25.2917 11.5309 25.775C12.0181 26.2583 12.6098 26.5 13.3059 26.5ZM24.0059 26.5C24.702 26.5 25.2917 26.2564 25.775 25.7691C26.2583 25.2819 26.5 24.6902 26.5 23.9941C26.5 23.298 26.2564 22.7083 25.7691 22.225C25.2819 21.7417 24.6902 21.5 23.9941 21.5C23.298 21.5 22.7083 21.7436 22.225 22.2309C21.7417 22.7181 21.5 23.3098 21.5 24.0059C21.5 24.702 21.7436 25.2917 22.2309 25.775C22.7181 26.2583 23.3098 26.5 24.0059 26.5ZM34.6559 26.5C35.352 26.5 35.9417 26.2564 36.425 25.7691C36.9083 25.2819 37.15 24.6902 37.15 23.9941C37.15 23.298 36.9064 22.7083 36.4191 22.225C35.9319 21.7417 35.3402 21.5 34.6441 21.5C33.948 21.5 33.3583 21.7436 32.875 22.2309C32.3917 22.7181 32.15 23.3098 32.15 24.0059C32.15 24.702 32.3936 25.2917 32.8809 25.775C33.3681 26.2583 33.9598 26.5 34.6559 26.5ZM24.0133 44C21.2555 44 18.6638 43.475 16.2383 42.425C13.8128 41.375 11.6917 39.9417 9.875 38.125C8.05833 36.3083 6.625 34.186 5.575 31.758C4.525 29.33 4 26.7356 4 23.975C4 21.2144 4.525 18.6201 5.575 16.1921C6.625 13.764 8.05833 11.65 9.875 9.85C11.6917 8.05 13.814 6.625 16.2421 5.575C18.6701 4.525 21.2644 4 24.025 4C26.7856 4 29.38 4.525 31.808 5.575C34.236 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2289 44 23.9867C44 26.7445 43.475 29.3362 42.425 31.7617C41.375 34.1872 39.95 36.3053 38.15 38.1158C36.35 39.9263 34.2333 41.3597 31.8 42.4158C29.3667 43.4719 26.7711 44 24.0133 44Z"
        fill="#FF6600"
      />
    </svg>
  ),
  RequestAccepted: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.05 33.1L35.2 18.95L32.9 16.7L21.05 28.55L15.05 22.55L12.8 24.8L21.05 33.1ZM24 44C21.2667 44 18.6833 43.475 16.25 42.425C13.8167 41.375 11.6917 39.9417 9.875 38.125C8.05833 36.3083 6.625 34.1833 5.575 31.75C4.525 29.3167 4 26.7333 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05833 11.65 9.875 9.85C11.6917 8.05 13.8167 6.625 16.25 5.575C18.6833 4.525 21.2667 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24C44 26.7333 43.475 29.3167 42.425 31.75C41.375 34.1833 39.95 36.3083 38.15 38.125C36.35 39.9417 34.2333 41.375 31.8 42.425C29.3667 43.475 26.7667 44 24 44Z"
        fill="#1BA000"
      />
    </svg>
  ),
  AdminWeb: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43 41.45V9H5V25H2V9C2 8.16667 2.29167 7.45833 2.875 6.875C3.45833 6.29167 4.16667 6 5 6H43C43.8333 6 44.5417 6.29167 45.125 6.875C45.7083 7.45833 46 8.16667 46 9V38C46 38.8667 45.7167 39.625 45.15 40.275C44.5833 40.925 43.8667 41.3167 43 41.45ZM18 27.95C15.8 27.95 14 27.25 12.6 25.85C11.2 24.45 10.5 22.65 10.5 20.45C10.5 18.25 11.2 16.45 12.6 15.05C14 13.65 15.8 12.95 18 12.95C20.2 12.95 22 13.65 23.4 15.05C24.8 16.45 25.5 18.25 25.5 20.45C25.5 22.65 24.8 24.45 23.4 25.85C22 27.25 20.2 27.95 18 27.95ZM2 44V39.3C2 38.0333 2.31667 36.95 2.95 36.05C3.58333 35.15 4.4 34.4667 5.4 34C7.63333 33 9.775 32.25 11.825 31.75C13.875 31.25 15.9333 31 18 31C20.0667 31 22.1167 31.2583 24.15 31.775C26.1833 32.2917 28.3167 33.0333 30.55 34C31.5833 34.4667 32.4167 35.15 33.05 36.05C33.6833 36.95 34 38.0333 34 39.3V44H2Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  AdminApp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.35 42L32.85 38.7C32.2833 38.5333 31.7083 38.2917 31.125 37.975C30.5417 37.6583 30.05 37.3 29.65 36.9L26.9 37.5L25.65 35.4L28 33.2C27.9333 32.9 27.9 32.4833 27.9 31.95C27.9 31.4167 27.9333 31 28 30.7L25.65 28.5L26.9 26.4L29.65 27C30.05 26.6 30.5417 26.2417 31.125 25.925C31.7083 25.6083 32.2833 25.3667 32.85 25.2L33.35 21.9H36.05L36.55 25.2C37.1167 25.3667 37.6917 25.6083 38.275 25.925C38.8583 26.2417 39.35 26.6 39.75 27L42.5 26.4L43.75 28.5L41.4 30.7C41.4667 31 41.5 31.4167 41.5 31.95C41.5 32.4833 41.4667 32.9 41.4 33.2L43.75 35.4L42.5 37.5L39.75 36.9C39.35 37.3 38.8583 37.6583 38.275 37.975C37.6917 38.2917 37.1167 38.5333 36.55 38.7L36.05 42H33.35ZM4 39.8V35.1C4 33.9333 4.29167 32.8833 4.875 31.95C5.45833 31.0167 6.3 30.3 7.4 29.8C9.8 28.7333 12.025 27.9667 14.075 27.5C16.125 27.0333 18.1 26.8 20 26.8H21.15C20.45 28.5 20.1333 30.7417 20.2 33.525C20.2667 36.3083 20.8333 38.4 21.9 39.8H4ZM34.7 35.95C35.9 35.95 36.8667 35.5833 37.6 34.85C38.3333 34.1167 38.7 33.15 38.7 31.95C38.7 30.75 38.3333 29.7833 37.6 29.05C36.8667 28.3167 35.9 27.95 34.7 27.95C33.5 27.95 32.5333 28.3167 31.8 29.05C31.0667 29.7833 30.7 30.75 30.7 31.95C30.7 33.15 31.0667 34.1167 31.8 34.85C32.5333 35.5833 33.5 35.95 34.7 35.95ZM20 23.75C17.8 23.75 16 23.05 14.6 21.65C13.2 20.25 12.5 18.45 12.5 16.25C12.5 14.05 13.2 12.25 14.6 10.85C16 9.45 17.8 8.75 20 8.75C22.2 8.75 24 9.45 25.4 10.85C26.8 12.25 27.5 14.05 27.5 16.25C27.5 18.45 26.8 20.25 25.4 21.65C24 23.05 22.2 23.75 20 23.75Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  LeadingApp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.5 28V21.5H30V18.5H36.5V12H39.5V18.5H46V21.5H39.5V28H36.5ZM18 23.95C15.8 23.95 14 23.25 12.6 21.85C11.2 20.45 10.5 18.65 10.5 16.45C10.5 14.25 11.2 12.45 12.6 11.05C14 9.65 15.8 8.95 18 8.95C20.2 8.95 22 9.65 23.4 11.05C24.8 12.45 25.5 14.25 25.5 16.45C25.5 18.65 24.8 20.45 23.4 21.85C22 23.25 20.2 23.95 18 23.95ZM2 40V35.3C2 34.1333 2.29167 33.075 2.875 32.125C3.45833 31.175 4.3 30.4667 5.4 30C7.9 28.9 10.125 28.125 12.075 27.675C14.025 27.225 16 27 18 27C20 27 21.9667 27.225 23.9 27.675C25.8333 28.125 28.05 28.9 30.55 30C31.65 30.5 32.5 31.2167 33.1 32.15C33.7 33.0833 34 34.1333 34 35.3V40H2Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  NotificationApp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.55 34.5C35.4167 34.5 36.15 34.1833 36.75 33.55C37.35 32.9167 37.65 32.1667 37.65 31.3C37.65 30.4333 37.35 29.7 36.75 29.1C36.15 28.5 35.4167 28.2 34.55 28.2C33.6833 28.2 32.9333 28.5 32.3 29.1C31.6667 29.7 31.35 30.4333 31.35 31.3C31.35 32.1667 31.6667 32.9167 32.3 33.55C32.9333 34.1833 33.6833 34.5 34.55 34.5ZM34.5 40.75C35.6 40.75 36.6 40.5167 37.5 40.05C38.4 39.5833 39.1667 38.9167 39.8 38.05C38.9333 37.5833 38.0667 37.2333 37.2 37C36.3333 36.7667 35.4333 36.65 34.5 36.65C33.5667 36.65 32.6583 36.7667 31.775 37C30.8917 37.2333 30.0333 37.5833 29.2 38.05C29.8333 38.9167 30.5917 39.5833 31.475 40.05C32.3583 40.5167 33.3667 40.75 34.5 40.75ZM34.65 44C32.05 44 29.8333 43.075 28 41.225C26.1667 39.375 25.25 37.1833 25.25 34.65C25.25 32.05 26.1667 29.825 28 27.975C29.8333 26.125 32.05 25.2 34.65 25.2C37.2167 25.2 39.425 26.125 41.275 27.975C43.125 29.825 44.05 32.05 44.05 34.65C44.05 37.1833 43.125 39.375 41.275 41.225C39.425 43.075 37.2167 44 34.65 44ZM24 44C19.4 42.9333 15.5833 40.325 12.55 36.175C9.51667 32.025 8 27.2667 8 21.9V9.95L24 3.95L40 9.95V23.45C39.1667 23.05 38.3 22.7417 37.4 22.525C36.5 22.3083 35.5833 22.2 34.65 22.2C31.2167 22.2 28.2917 23.4167 25.875 25.85C23.4583 28.2833 22.25 31.2167 22.25 34.65C22.25 36.25 22.575 37.8167 23.225 39.35C23.875 40.8833 24.7667 42.2167 25.9 43.35C25.6 43.5167 25.2833 43.6417 24.95 43.725C24.6167 43.8083 24.3 43.9 24 44Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  StaffApp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.9 40V35.3C1.9 34.1333 2.2 33.075 2.8 32.125C3.4 31.175 4.23333 30.4667 5.3 30C7.73333 28.9333 9.925 28.1667 11.875 27.7C13.825 27.2333 15.8333 27 17.9 27C19.9667 27 21.9667 27.2333 23.9 27.7C25.8333 28.1667 28.0167 28.9333 30.45 30C31.5167 30.4667 32.3583 31.175 32.975 32.125C33.5917 33.075 33.9 34.1333 33.9 35.3V40H1.9ZM36.9 40V35.3C36.9 33.2 36.3667 31.475 35.3 30.125C34.2333 28.775 32.8333 27.6833 31.1 26.85C33.4 27.1167 35.5667 27.5083 37.6 28.025C39.6333 28.5417 41.2833 29.1333 42.55 29.8C43.65 30.4333 44.5167 31.2167 45.15 32.15C45.7833 33.0833 46.1 34.1333 46.1 35.3V40H36.9ZM17.9 23.95C15.7 23.95 13.9 23.25 12.5 21.85C11.1 20.45 10.4 18.65 10.4 16.45C10.4 14.25 11.1 12.45 12.5 11.05C13.9 9.65 15.7 8.95 17.9 8.95C20.1 8.95 21.9 9.65 23.3 11.05C24.7 12.45 25.4 14.25 25.4 16.45C25.4 18.65 24.7 20.45 23.3 21.85C21.9 23.25 20.1 23.95 17.9 23.95ZM35.9 16.45C35.9 18.65 35.2 20.45 33.8 21.85C32.4 23.25 30.6 23.95 28.4 23.95C28.0333 23.95 27.625 23.925 27.175 23.875C26.725 23.825 26.3167 23.7333 25.95 23.6C26.75 22.7667 27.3583 21.7417 27.775 20.525C28.1917 19.3083 28.4 17.95 28.4 16.45C28.4 14.95 28.1917 13.625 27.775 12.475C27.3583 11.325 26.75 10.2667 25.95 9.3C26.3167 9.2 26.725 9.11666 27.175 9.05C27.625 8.98333 28.0333 8.95 28.4 8.95C30.6 8.95 32.4 9.65 33.8 11.05C35.2 12.45 35.9 14.25 35.9 16.45Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  CreateNewAudit: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.95 35.5H32.05V32.5H15.95V35.5ZM15.95 27H32.05V24H15.95V27ZM11 44C10.2 44 9.5 43.7 8.9 43.1C8.3 42.5 8 41.8 8 41V7C8 6.2 8.3 5.5 8.9 4.9C9.5 4.3 10.2 4 11 4H29.05L40 14.95V41C40 41.8 39.7 42.5 39.1 43.1C38.5 43.7 37.8 44 37 44H11ZM27.55 16.3V7H11V41H37V16.3H27.55Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  EditAudit: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      viewBox="0 96 960 960"
      width="48"
      fill="#1C4F96"
      {...props}
    >
      <path d="M780 896H260q-24 0-42-18t-18-42V196q0-24 18-42t42-18h348l232 232v468q0 24-18 42t-42 18ZM578 394V196H260v640h520V394H578Zm-438 622q-24 0-42-18t-18-42V337h60v619h498v60H140Zm120-820v198-198 640-640Z" />
    </svg>
  ),
  Induction: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 40C22.4 38.7333 20.6667 37.75 18.8 37.05C16.9333 36.35 15 36 13 36C11.6 36 10.225 36.1833 8.875 36.55C7.525 36.9167 6.23333 37.4333 5 38.1C4.3 38.4667 3.625 38.45 2.975 38.05C2.325 37.65 2 37.0667 2 36.3V12.2C2 11.8333 2.09167 11.4833 2.275 11.15C2.45833 10.8167 2.73333 10.5667 3.1 10.4C4.63333 9.6 6.23333 9 7.9 8.6C9.56667 8.2 11.2667 8 13 8C14.9333 8 16.825 8.25 18.675 8.75C20.525 9.25 22.3 10 24 11V36.3C25.7 35.2 27.4833 34.375 29.35 33.825C31.2167 33.275 33.1 33 35 33C36.2 33 37.5083 33.1167 38.925 33.35C40.3417 33.5833 41.7 34.0667 43 34.8V9.55C43.3295 9.675 43.6536 9.80625 43.9722 9.94375C44.2907 10.0813 44.6 10.2333 44.9 10.4C45.2333 10.6 45.5 10.8613 45.7 11.1839C45.9 11.5065 46 11.8452 46 12.2V36.3C46 37.0667 45.675 37.65 45.025 38.05C44.375 38.45 43.7 38.4667 43 38.1C41.7667 37.4333 40.475 36.9167 39.125 36.55C37.775 36.1833 36.4 36 35 36C33 36 31.0667 36.35 29.2 37.05C27.3333 37.75 25.6 38.7333 24 40ZM27 31.65V14L40 1V20.35L27 31.65ZM21 34.8V12.85C19.8667 12.2167 18.55 11.75 17.05 11.45C15.55 11.15 14.2 11 13 11C11.4333 11 9.975 11.1667 8.625 11.5C7.275 11.8333 6.06667 12.2589 5 12.7767V34.8C6.16667 34.2333 7.425 33.7917 8.775 33.475C10.125 33.1583 11.5417 33 13.025 33C14.5083 33 15.9167 33.1583 17.25 33.475C18.5833 33.7917 19.8333 34.2333 21 34.8Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  Mobile: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm200-100q17 0 28.5-11.5T520-180q0-17-11.5-28.5T480-220q-17 0-28.5 11.5T440-180q0 17 11.5 28.5T480-140ZM280-320h400v-400H280v400Z" />
    </svg>
  ),
  Web: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M320-120v-80h80v-80H160q-33 0-56.5-23.5T80-360v-400q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v400q0 33-23.5 56.5T800-280H560v80h80v80H320ZM160-360h640v-400H160v400Zm0 0v-400 400Z" />
    </svg>
  ),
};

export const imageUtils = {
  accountSetup: "/assets/images/pricingImages/account-setup.jpg",
  audit: "/assets/images/pricingImages/audit.jpg",
  auditSharing: "/assets/images/pricingImages/audit_sharing.jpg",
  businessEssentials: "/assets/images/pricingImages/business-essentials.jpg",
  businessPack: "/assets/images/pricingImages/business-pack.jpg",
  callCenter: "/assets/images/pricingImages/call-center.jpg",
  enterprise: "/assets/images/pricingImages/enterprise.jpg",
  financialTools: "/assets/images/pricingImages/financial-tools.jpg",
  hazard: "/assets/images/pricingImages/hazard.jpg",
  induction: "/assets/images/pricingImages/induction.jpg",
  mediumBusiness: "/assets/images/pricingImages/medium-business.jpg",
  msRw: "/assets/images/pricingImages/MS-RW.jpg",
  nahAcc: "/assets/images/pricingImages/NAH-acc.jpg",
  onsiteTraining: "/assets/images/pricingImages/onsite-training.jpg",
  pahAcc: "/assets/images/pricingImages/PAH-acc.jpg",
  sahAcc: "/assets/images/pricingImages/SAH-acc.jpg",
  smallBusiness1: "/assets/images/pricingImages/small-business-1.jpg",
  smallBusiness2: "/assets/images/pricingImages/small-business-2.jpg",
  swmsJsa: "/assets/images/pricingImages/swms-jsa.jpg",
  workAssessment: "/assets/images/pricingImages/work-assessment.jpg",
};

export const HeaderSvgs = {
  HeaderCalendar: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M480-400q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z" />
    </svg>
  ),
  HeaderEmail: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280 320-200v-80L480-520 160-720v80l320 200Z" />
    </svg>
  ),
  HeaderGear: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm112-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z" />
    </svg>
  ),
  HeaderQuestionMark: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M424-320q0-81 14.5-116.5T500-514q41-36 62.5-62.5T584-637q0-41-27.5-68T480-732q-51 0-77.5 31T365-638l-103-44q21-64 77-111t141-47q105 0 161.5 58.5T698-641q0 50-21.5 85.5T609-475q-49 47-59.5 71.5T539-320H424Zm56 240q-33 0-56.5-23.5T400-160q0-33 23.5-56.5T480-240q33 0 56.5 23.5T560-160q0 33-23.5 56.5T480-80Z" />
    </svg>
  ),
};

export const HomeMenuIcons = {
  HomeIcon1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M360-440h80v-110h80v110h80v-190l-120-80-120 80v190ZM480-80Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z" />
    </svg>
  ),
  HomeIcon2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v120q-23 5-43 16t-37 28L480-237v157H240Zm320 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm263-224 37-39-37-37-38 38 38 38ZM520-600h200L520-800l200 200-200-200v200Z" />
    </svg>
  ),
  HomeIcon3: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-80q-33 0-56.5-23.5T80-160v-440q0-33 23.5-56.5T160-680h200v-120q0-33 23.5-56.5T440-880h80q33 0 56.5 23.5T600-800v120h200q33 0 56.5 23.5T880-600v440q0 33-23.5 56.5T800-80H160Zm80-160h240v-18q0-17-9.5-31.5T444-312q-20-9-40.5-13.5T360-330q-23 0-43.5 4.5T276-312q-17 8-26.5 22.5T240-258v18Zm320-60h160v-60H560v60Zm-200-60q25 0 42.5-17.5T420-420q0-25-17.5-42.5T360-480q-25 0-42.5 17.5T300-420q0 25 17.5 42.5T360-360Zm200-60h160v-60H560v60ZM440-600h80v-200h-80v200Z" />
    </svg>
  ),
  HomeIcon4: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Z" />
    </svg>
  ),
  HomeIcon5: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h360l200 240v466L618-360q11-17 16.5-37t5.5-43q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47q23 0 43-5.5t37-16.5L768-96q-23 10-48 13t-50 3H240Zm240-280q-33 0-56.5-23.5T400-440q0-33 23.5-56.5T480-520q33 0 56.5 23.5T560-440q0 33-23.5 56.5T480-360Z" />
    </svg>
  ),
  HomeIcon6: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M840-280v-276L480-360 40-600l440-240 440 240v320h-80ZM480-120 200-272v-200l280 152 280-152v200L480-120Z" />
    </svg>
  ),
  HomeIcon7: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M240-80q-33 0-56.5-23.5T160-160v-480l240-240h320q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80H240Zm240-200q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-200h-80v200Z" />
    </svg>
  ),
  HomeIcon8: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm80-160h200v-80H240v80Zm0-160h200v-80H240v80Zm0-160h200v-80H240v80Zm400 320h80v-80h-80v80Zm0-160h80v-240h-80v240Z" />
    </svg>
  ),
  HomeIcon9: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M222-200 80-342l56-56 85 85 170-170 56 57-225 226Zm0-320L80-662l56-56 85 85 170-170 56 57-225 226Zm298 240v-80h360v80H520Zm0-320v-80h360v80H520Z" />
    </svg>
  ),
  HomeIcon10: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M80-80v-80q46 0 91-6t88-22q-46-23-72.5-66.5T160-349v-91h160v-120h135L324-822l72-36 131 262q20 40-3 78t-68 38h-56v40q0 33-23.5 56.5T320-360h-80v11q0 35 21.5 61.5T316-252l12 3q40 10 45 50t-31 60q-60 33-126.5 46T80-80Zm572-114-57-56q21-21 33-48.5t12-59.5q0-32-12-59.5T595-466l57-57q32 32 50 74.5t18 90.5q0 48-18 90t-50 74ZM765-80l-57-57q43-43 67.5-99.5T800-358q0-66-24.5-122T708-579l57-57q54 54 84.5 125T880-358q0 81-30.5 152.5T765-80Z" />
    </svg>
  ),
  HomeIcon11: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M444-200h70v-50q50-9 86-39t36-89q0-42-24-77t-96-61q-60-20-83-35t-23-41q0-26 18.5-41t53.5-15q32 0 50 15.5t26 38.5l64-26q-11-35-40.5-61T516-710v-50h-70v50q-50 11-78 44t-28 74q0 47 27.5 76t86.5 50q63 23 87.5 41t24.5 47q0 33-23.5 48.5T486-314q-33 0-58.5-20.5T390-396l-66 26q14 48 43.5 77.5T444-252v52Zm36 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  HomeIcon12: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-120q-33 0-56.5-23.5T80-200v-640l67 67 66-67 67 67 67-67 66 67 67-67 67 67 66-67 67 67 67-67 66 67 67-67v640q0 33-23.5 56.5T800-120H160Zm0-80h280v-240H160v240Zm360 0h280v-80H520v80Zm0-160h280v-80H520v80ZM160-520h640v-120H160v120Z" />
    </svg>
  ),
  HomeIcon13: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M320-160q-33 0-56.5-23.5T240-240v-120h120v-90q-35-2-66.5-15.5T236-506v-44h-46L60-680q36-46 89-65t107-19q27 0 52.5 4t51.5 15v-55h480v520q0 50-35 85t-85 35H320Zm120-200h240v80q0 17 11.5 28.5T720-240q17 0 28.5-11.5T760-280v-440H440v24l240 240v56h-56L510-514l-8 8q-14 14-29.5 25T440-464v104ZM224-630h92v86q12 8 25 11t27 3q23 0 41.5-7t36.5-25l8-8-56-56q-29-29-65-43.5T256-684q-20 0-38 3t-36 9l42 42Z" />
    </svg>
  ),
  HomeIcon14: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm280-670q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790Z" />
    </svg>
  ),
  HomeIcon15: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z" />
    </svg>
  ),
  HomeIcon16: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M360-460h40v-80h40q17 0 28.5-11.5T480-580v-40q0-17-11.5-28.5T440-660h-80v200Zm40-120v-40h40v40h-40Zm120 120h80q17 0 28.5-11.5T640-500v-120q0-17-11.5-28.5T600-660h-80v200Zm40-40v-120h40v120h-40Zm120 40h40v-80h40v-40h-40v-40h40v-40h-80v200ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Z" />
    </svg>
  ),
  HomeIcon17: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M480-79q-16 0-30.5-6T423-102L102-423q-11-12-17-26.5T79-480q0-16 6-31t17-26l321-321q12-12 26.5-17.5T480-881q16 0 31 5.5t26 17.5l321 321q12 11 17.5 26t5.5 31q0 16-5.5 30.5T858-423L537-102q-11 11-26 17t-31 6Zm-40-361h80v-240h-80v240Zm40 120q17 0 28.5-11.5T520-360q0-17-11.5-28.5T480-400q-17 0-28.5 11.5T440-360q0 17 11.5 28.5T480-320Z" />
    </svg>
  ),
  HomeIcon18: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M440-280h80l12-60q12-5 22.5-10.5T576-364l58 18 40-68-46-40q2-14 2-26t-2-26l46-40-40-68-58 18q-11-8-21.5-13.5T532-620l-12-60h-80l-12 60q-12 5-22.5 10.5T384-596l-58-18-40 68 46 40q-2 14-2 26t2 26l-46 40 40 68 58-18q11 8 21.5 13.5T428-340l12 60Zm40-120q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z" />
    </svg>
  ),
};

export const SideIcons = {
  SideFile: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="m680-80-12-60q-12-5-22.5-10.5T624-164l-58 18-40-68 46-40q-2-12-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T668-420l12-60h80l12 60q12 5 22.5 10.5T816-396l58-18 40 68-46 40q2 12 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T772-140l-12 60h-80Zm40-120q33 0 56.5-23.5T800-280q0-33-23.5-56.5T720-360q-33 0-56.5 23.5T640-280q0 33 23.5 56.5T720-200Zm-560 40q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v131q-35-25-76-38t-85-13q-118 0-198.5 82.5T440-281q0 32 7 62t21 59H160Z" />
    </svg>
  ),
  SideGear: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M440-280h80l12-60q12-5 22.5-10.5T576-364l58 18 40-68-46-40q2-14 2-26t-2-26l46-40-40-68-58 18q-11-8-21.5-13.5T532-620l-12-60h-80l-12 60q-12 5-22.5 10.5T384-596l-58-18-40 68 46 40q-2 14-2 26t2 26l-46 40 40 68 58-18q11 8 21.5 13.5T428-340l12 60Zm40-120q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z" />
    </svg>
  ),
  SideReport: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M680-80q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80Zm0-80q11 0 18.5-7.5T706-186q0-11-7.5-18.5T680-212q-11 0-18.5 7.5T654-186q0 11 7.5 18.5T680-160Zm-18-76h36v-10q0-11 6-19.5t14-16.5q14-12 22-23t8-31q0-29-19-46.5T680-400q-23 0-41.5 13.5T612-350l32 14q3-12 12.5-21t23.5-9q15 0 23.5 7.5T712-336q0 11-6 18.5T692-302q-6 6-12.5 12T668-276q-3 6-4.5 12t-1.5 14v14ZM480-600h200L480-800l200 200-200-200v200ZM200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h320l240 240v92q-20-6-40-9t-40-3q-57 0-107.5 21.5T484-480H280v80h147q-9 19-15 39t-9 41H280v80h123q7 45 28 86.5T485-80H200Z" />
    </svg>
  ),
  SideTools: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M756-120 537-339l84-84 219 219-84 84Zm-552 0-84-84 276-276-68-68-28 28-51-51v82l-28 28-121-121 28-28h82l-50-50 142-142q20-20 43-29t47-9q24 0 47 9t43 29l-92 92 50 50-28 28 68 68 90-90q-4-11-6.5-23t-2.5-24q0-59 40.5-99.5T701-841q15 0 28.5 3t27.5 9l-99 99 72 72 99-99q7 14 9.5 27.5T841-701q0 59-40.5 99.5T701-561q-12 0-24-2t-23-7L204-120Z" />
    </svg>
  ),
};

export const AuditSvgsRaw = {
  AuditCloning: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M480-320q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400ZM661-80q18-56 27-100t14-70q-43 42-100 66t-122 24q-136 0-238.5-18.5T80-214v-85q56 18 100 27t70 14q-42-43-66-100t-24-122q0-137 18.5-239T214-880h85q-18 56-27.5 100T258-710q43-42 100-66t122-24q137 0 239 18.5T880-746v85q-56-18-100-27.5T710-702q42 43 66 100t24 122q0 137-18.5 239T746-80h-85ZM480-240q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70Z" />
    </svg>
  ),
  AuditToolMenuItem1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path
        d="M80-720v-200h200v80H160v120H80Zm720 0v-120H680v-80h200v200h-80ZM80-40v-200h80v120h120v80H80Zm600 0v-80h120v-120h80v200H680ZM280-240h400v-480H280v480Zm0 80q-33 0-56.5-23.5T200-240v-480q0-33 23.5-56.5T280-800h400q33 0 56.5 23.5T760-720v480q0 33-23.5 56.5T680-160H280Zm80-400h240v-80H360v80Zm0 120h240v-80H360v80Zm0 120h240v-80H360v80Zm-80 80v-480 480Z"
        fill="#1C4F96"
      />
    </svg>
  ),
  AuditToolMenuItem2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1C4F96"
      {...props}
    >
      <path d="M320-160q-33 0-56.5-23.5T240-240v-120h120v-90q-35-2-66.5-15.5T236-506v-44h-46L60-680q36-46 89-65t107-19q27 0 52.5 4t51.5 15v-55h480v520q0 50-35 85t-85 35H320Zm120-200h240v80q0 17 11.5 28.5T720-240q17 0 28.5-11.5T760-280v-440H440v24l240 240v56h-56L510-514l-8 8q-14 14-29.5 25T440-464v104ZM224-630h92v86q12 8 25 11t27 3q23 0 41.5-7t36.5-25l8-8-56-56q-29-29-65-43.5T256-684q-20 0-38 3t-36 9l42 42Zm376 350H320v40h286q-3-9-4.5-19t-1.5-21Zm-280 40v-40 40Z" />
    </svg>
  ),
  RecipientSVG: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M560-520h280v-200H560v200Zm140-50-100-70v-40l100 70 100-70v40l-100 70ZM80-120q-33 0-56.5-23.5T0-200v-560q0-33 23.5-56.5T80-840h800q33 0 56.5 23.5T960-760v560q0 33-23.5 56.5T880-120H80Zm280-280q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM84-200h552q-42-75-116-117.5T360-360q-86 0-160 42.5T84-200Z" />
    </svg>
  ),
  QuestionNotifyManagement: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="m760-40-56-56 63-64H600v-80h167l-64-64 57-56 160 160L760-40ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v312q-27-16-57.5-24t-62.5-8q-100 0-170 70t-70 170v40H160Zm320-280 320-200v-80L480-520 160-720v80l320 200Z" />
    </svg>
  ),

  QuestionAddComponent: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M520-400h80v-120h120v-80H600v-120h-80v120H400v80h120v120ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Z"></path>
    </svg>
  ),
  QuestionAddSection: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path
        d="M440-240h80v-120h120v-80H520v-120h-80v120H320v80h120v120ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520h200L520-800v200Z"
        fill="#ffffff"
      ></path>
    </svg>
  ),
  QuestionDelete: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm80-160h80v-360h-80v360Zm160 0h80v-360h-80v360Z" />
    </svg>
  ),
  QuestionDragDrop: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M480-80 310-250l57-57 73 73v-166h80l-1 165 73-73 58 58L480-80ZM250-310 80-480l169-169 57 57-72 72h166v80H235l73 72-58 58Zm460 0-57-57 73-73H560v-80l165 1-73-73 58-58 170 170-170 170ZM440-560v-166l-73 73-57-57 170-170 170 170-57 57-73-73v166h-80Z" />
    </svg>
  ),
  QuestionType0Select: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M560-360q17 0 29.5-12.5T602-402q0-17-12.5-29.5T560-444q-17 0-29.5 12.5T518-402q0 17 12.5 29.5T560-360Zm-30-128h60q0-29 6-42.5t28-35.5q30-30 40-48.5t10-43.5q0-45-31.5-73.5T560-760q-41 0-71.5 23T446-676l54 22q9-25 24.5-37.5T560-704q24 0 39 13.5t15 36.5q0 14-8 26.5T578-596q-33 29-40.5 45.5T530-488ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Z"></path>
    </svg>
  ),
  QuestionType1QASub1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M400-200 120-480l280-280v560Zm-60-145v-270L205-480l135 135Zm220 145v-560l280 280-280 280Z"></path>
    </svg>
  ),
  QuestionType1QASub2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M480-280q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680q-83 0-141.5 58.5T280-480q0 83 58.5 141.5T480-280Zm0 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path>
    </svg>
  ),
  QuestionType1QASub3: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="m508-398 226-226-56-58-170 170-86-84-56 56 142 142ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Z"></path>
    </svg>
  ),
  QuestionType1QA: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm40-160h200v-80H200v80Zm382-80 198-198-57-57-141 142-57-57-56 57 113 113Zm-382-80h200v-80H200v80Zm0-160h200v-80H200v80Z"></path>
    </svg>
  ),
  QuestionType2TextEntrySub1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-200q-33 0-56.5-23.5T80-280v-400q0-33 23.5-56.5T160-760h640q33 0 56.5 23.5T880-680v400q0 33-23.5 56.5T800-200H160Zm160-120h320v-80H320v80ZM200-440h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80ZM200-560h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Z"></path>
    </svg>
  ),
  QuestionType2TextEntrySub2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm100-200h46v-240h-36l-70 50 24 36 36-26v180Zm124 0h156v-40h-94l-2-2q21-20 34.5-34t21.5-22q18-18 27-36t9-38q0-29-22-48.5T458-600q-26 0-47 15t-29 39l40 16q5-13 14.5-20.5T458-558q15 0 24.5 8t9.5 20q0 11-4 20.5T470-486l-32 32-54 54v40Zm296 0q36 0 58-20t22-52q0-18-10-32t-28-22v-2q14-8 22-20.5t8-29.5q0-27-21-44.5T678-600q-25 0-46.5 14.5T604-550l40 16q4-12 13-19t21-7q13 0 21.5 7.5T708-534q0 14-10 22t-26 8h-18v40h20q20 0 31 8t11 22q0 13-11 22.5t-25 9.5q-17 0-26-7.5T638-436l-40 16q7 29 28.5 44.5T680-360Z"></path>
    </svg>
  ),
  QuestionType2TextEntry: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M280-280h84l240-238-86-86-238 238v86Zm352-266 42-44q6-6 6-14t-6-14l-56-56q-6-6-14-6t-14 6l-44 42 86 86ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm280-670q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790Z"></path>
    </svg>
  ),
  QuestionType3InfoInputSub1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm424-368 57-56-56-56-57 56 56 56ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357L280-563v283h282l278-278v358q0 33-23.5 56.5T760-120H200Z"></path>
    </svg>
  ),
  QuestionType3InfoInputSub2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M280-240q-100 0-170-70T40-480q0-100 70-170t170-70h400q100 0 170 70t70 170q0 100-70 170t-170 70H280Zm400-120q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"></path>
    </svg>
  ),
  QuestionType3InfoInputSub3: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Z"></path>
    </svg>
  ),
  QuestionType3InfoInputSub4: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  QuestionType3InfoInput: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M300-360h60v-160h-60v50h-60v60h60v50Zm100-50h320v-60H400v60Zm200-110h60v-50h60v-60h-60v-50h-60v160Zm-360-50h320v-60H240v60Zm80 450v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320Z"></path>
    </svg>
  ),
  QuestionType4UploadMediaSub1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm-40 280v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Z"></path>
    </svg>
  ),
  QuestionType4UploadMediaSub2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M480-260q75 0 127.5-52.5T660-440q0-75-52.5-127.5T480-620q-75 0-127.5 52.5T300-440q0 75 52.5 127.5T480-260Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Z"></path>
    </svg>
  ),
  QuestionType4UploadMediaSub3: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z"></path>
    </svg>
  ),
  QuestionType4UploadMedia: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm280-120h80v-168l64 64 56-56-160-160-160 160 56 56 64-64v168Z"></path>
    </svg>
  ),
  QuestionType5DisplayInfoSub1: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M120-120q-33 0-56.5-23.5T40-200v-520h80v520h680v80H120Zm160-160q-33 0-56.5-23.5T200-360v-440q0-33 23.5-56.5T280-880h200l80 80h280q33 0 56.5 23.5T920-720v360q0 33-23.5 56.5T840-280H280Zm80-160h400L622-620l-92 120-62-80-108 140Z"></path>
    </svg>
  ),
  QuestionType5DisplayInfoSub2: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="m260-260 300-140 140-300-300 140-140 300Zm220-180q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520q17 0 28.5 11.5T520-480q0 17-11.5 28.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path>
    </svg>
  ),
  QuestionType5DisplayInfo: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="#1d65a6"
      {...props}
    >
      <path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm0-80h80v-80h-80v80Zm560 0h80v-80h-80v80Zm-280-80h80v-240h-80v240Zm-280-80h80v-80h-80v80Zm560 0h80v-80h-80v80ZM160-520h80v-80h-80v80Zm560 0h80v-80h-80v80Zm-240-80q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm-320-80h80v-80h-80v80Zm560 0h80v-80h-80v80Z"></path>
    </svg>
  ),
  QuestionHeaderIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm80-160h320v-80H240v80Zm400 0h80v-80h-80v80ZM240-480h80v-80h-80v80Zm160 0h320v-80H400v80Z"></path>
    </svg>
  ),
};
